import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '../Button/Button';

const ProductName = (props) => {
  const { children, className, href, lineLimit, onClick, ...rest } = props;

  const isClickable = href || onClick;
  const Element = isClickable ? Button : 'span';
  const clampClassName = `o-clamp-line o-clamp-line--${lineLimit}-line`;

  return (
    <Element
      title={children}
      className={cn('c-product__name u-text-bold', className)}
      {...(isClickable ? { color: 'inline-link', href, onClick } : {})}
      {...rest}
    >
      {lineLimit > 0 ? (
        <span className={clampClassName}>{children}</span>
      ) : (
        children
      )}
    </Element>
  );
};

export default ProductName;

ProductName.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  lineLimit: PropTypes.number,
  onClick: PropTypes.func,
};

ProductName.defaultProps = {
  className: '',
  href: null,
  lineLimit: 0,
  onClick: null,
};
